import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { companiesAPI } from '../../services/api';

export const fetchCompanies = createAsyncThunk('companies/fetchAll', async (params, { rejectWithValue }) => {
  try { const res = await companiesAPI.list(params); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to load companies'); }
});

export const createCompany = createAsyncThunk('companies/create', async (data, { rejectWithValue }) => {
  try { const res = await companiesAPI.create(data); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to create company'); }
});

export const updateCompany = createAsyncThunk('companies/update', async ({ id, data }, { rejectWithValue }) => {
  try { const res = await companiesAPI.update(id, data); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to update company'); }
});

const companiesSlice = createSlice({
  name: 'companies',
  initialState: { items: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.companies;
      })
      .addCase(fetchCompanies.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.items.push(action.payload.company);
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        const idx = state.items.findIndex(c => c._id === action.payload.company._id);
        if (idx !== -1) state.items[idx] = { ...state.items[idx], ...action.payload.company };
      });
  },
});

export default companiesSlice.reducer;
